import jstz from 'jstz';
import React, { FunctionComponent, useEffect } from 'react';
import { useAccount } from '../../hooks/useAccount';
import { useUpdateTimezoneSetting } from '../../hooks/useAccountMutations';
import { AppSetting } from '../../services/models/app-settings';

const TimezoneInferer: FunctionComponent = () => {
  const { account } = useAccount();
  const { updateTimezoneSetting, isUpdatingTimezone } = useUpdateTimezoneSetting();

  const settings = account?.settings || null;

  const areSettingsLoaded = !!settings && settings.length > 0;

  const timezoneSetting = settings
    ? settings.find(x => x.name === AppSetting.Timezone) || null
    : null;

  useEffect(() => {
    if (areSettingsLoaded && !isUpdatingTimezone && (!timezoneSetting || !timezoneSetting.value)) {
      const timezone = jstz.determine();
      const inferedTimeZone = timezone.name();
      updateTimezoneSetting(inferedTimeZone);
    }
  }, [timezoneSetting, areSettingsLoaded, isUpdatingTimezone, updateTimezoneSetting]);

  return <></>;
};

export default TimezoneInferer;
